import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { PaymentMethodsField } from "@modules/payment-methods";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../../hooks/useOrderFormik";
import useOrderPrice from "../../hooks/useOrderPrice";
import SectionTitle from "../common/SectionTitle";

const PaymentMethods: FC = () => {
  const { t } = useTranslation();

  const {
    errors: { [OrderFields.PAYMENT_METHOD]: fieldError },
    touched: { [OrderFields.PAYMENT_METHOD]: isTouched },
  } = useOrderFormik();

  const {
    staticData: { paymentMethods },
  } = useOrderData();

  const { rawPrice } = useOrderPrice();

  if (rawPrice === 0) {
    return null;
  }

  return (
    <Box data-field={OrderFields.PAYMENT_METHOD}>
      <SectionTitle>{t("order-summary-choose_payment_method")}</SectionTitle>
      <PaymentMethodsField
        name={OrderFields.PAYMENT_METHOD}
        paymentMethods={paymentMethods}
        fieldError={isTouched ? fieldError : undefined}
      />
    </Box>
  );
};
export default PaymentMethods;
